/**
 * 功能：“数值”类型数据转换
 * 参数：
 *      number-radio：         比率（倍数、系数）
 *      number-precision：     精度（小数位数）
 *      number-thousand-sign： 千分位（是否显示千分位，默认：不显示）
 *      number-min-value:      最小值（小于最小值显示最小值）
 *      number-max-value:      最大值（大于最大值显示最大值）
 */

export function format(column, value)
{
  let radio = column.numberRadio;
  let precision = column.numberPrecision;
  let thousandSign = column.numberThousandSign;
  let minValue = column.numberMinValue;
  let maxValue = column.numberMaxValue;
  // 是否null值
  if (value == null)
    return null;
  // 比率
  if (typeof (radio) != "undefined")
    value *= radio;
  // 最小值
  if (minValue != undefined)
  {
    if (value < minValue)
      value = minValue;
  }
  // 最大值
  if (maxValue != undefined)
  {
    if (value > maxValue)
      value = maxValue;
  }
  // 精度
  if (typeof (precision) != "undefined")
  {
    value = value.toFixed(precision);
  }
  // 格式化末尾的0
  value = formatZeroOfEnd(value);
  // 千分位
  if (typeof (thousandSign) != "undefined" && thousandSign == true)
    value = formatThousandSign(value);
  return value;
}

// 格式化千分位
function formatThousandSign(value)
{
  return value.toString().replace(/\d+/, function (n)
  {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1)
    {
      // 对整数部分添加分隔符
      return $1 + ",";
    });
  });
}

// 格式化末尾的0 
function formatZeroOfEnd(value)
{
  // 非数值或字符串直接返回原值
  if (typeof (value) !== 'number' && typeof (value) !== 'string')
    return value;
  // 数值转字符串
  if (typeof (value) === 'number')
    value = value.toFixed(8);
  // 查找小数点
  let dotPos = value.indexOf('.');
  if (dotPos >= 0)
  {
    // 去除末尾的0
    let zeroPos = -1;
    for (let i = value.length - 1; i >= 0; --i)
    {
      if (value.charAt(i) !== '0')
        break;
      zeroPos = i;
    }
    // 去除最后的小数点
    if (zeroPos == dotPos + 1)
      zeroPos = dotPos;
    // 截取
    if (zeroPos >= 0)
      value = value.substr(0, zeroPos)
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/Slot/Number.js